const stopEventPropagation = (e) => {
  e.stopPropagation()
}

export default stopEventPropagation
